import styles from "./styles.module.scss"
import Page from "./widget";

export default Page;
export {styles};